import { useTranslation } from 'react-i18next';

import { PlanSection } from '~/modules/artist-roster/pages/artist-details/pages/media-planner/components/PlanWizard/components/PlanSection';

export function PlanDetailsSection() {
  const { t } = useTranslation('campaign-planner', {
    keyPrefix: 'digitalCampaigns',
  });

  return (
    <PlanSection
      title={t('planWizard.sections.planDetails.title')}
      isRequired={false}
      isOpen={true}
    >
      {/* eslint-disable-next-line i18next/no-literal-string */}
      <p>@TODO WMG1-652 - Campaign plan details</p>
    </PlanSection>
  );
}

PlanDetailsSection.displayName = 'PlanDetailsSection';
